'use client';

import { useEffect, useState } from 'react';
import { Box } from '@chakra-ui/react';
import Image from 'next/image';
import ChatbotIcon from './assets/chatbot.svg';
declare global {
  interface Window {
    HubSpotConversations?: {
      widget: {
        open: () => void;
        close: () => void;
        refresh: () => void;
        status: () => {
          loaded: boolean;
        };
      };
      on: (event: string, callback: () => void) => void;
    };
  }
}
const CHAT_BUTTON_SIZE = 60;
const HUBSPOT_CHECK_INTERVAL_MS = 100;
const HUBSPOT_WIDGET_LOAD_DELAY_MS = 2000;
export default function HubSpotChatButton() {
  const [isHubSpotReady, setIsHubSpotReady] = useState(false);
  const [isChatOpen, setIsChatOpen] = useState(false);
  useEffect(() => {
    const setupEventListeners = () => {
      if (window.HubSpotConversations?.on) {
        window.HubSpotConversations.on('widgetOpen', () => {
          setIsChatOpen(true);
        });
        window.HubSpotConversations.on('widgetClose', () => {
          setIsChatOpen(false);
        });
      }
    };
    const checkHubSpotWidget = setInterval(() => {
      const hasHubSpotWidget = window.HubSpotConversations && window.HubSpotConversations.widget && typeof window.HubSpotConversations.widget.open === 'function';
      if (hasHubSpotWidget) {
        setIsHubSpotReady(true);
        clearInterval(checkHubSpotWidget);
        setupEventListeners();
      }
    }, HUBSPOT_CHECK_INTERVAL_MS);
    const fallbackCheck = setTimeout(() => {
      const hasHubSpotWidget = window.HubSpotConversations && window.HubSpotConversations.widget && typeof window.HubSpotConversations.widget.open === 'function';
      if (hasHubSpotWidget) {
        setIsHubSpotReady(true);
        setupEventListeners();
      }
    }, HUBSPOT_WIDGET_LOAD_DELAY_MS);
    return () => {
      clearInterval(checkHubSpotWidget);
      clearTimeout(fallbackCheck);
    };
  }, []);
  const handleToggleChat = () => {
    if (window.HubSpotConversations && window.HubSpotConversations.widget) {
      if (isChatOpen) {
        window.HubSpotConversations.widget.close();
        setIsChatOpen(false);
      } else {
        window.HubSpotConversations.widget.open();
        setIsChatOpen(true);
      }
    }
  };
  if (!isHubSpotReady) {
    return null;
  }
  return <Box as="button" position="fixed" bottom={{
    base: '128px',
    tablet: '20px'
  }} right="20px" width={`${CHAT_BUTTON_SIZE}px`} height={`${CHAT_BUTTON_SIZE}px`} borderRadius="50%" cursor="pointer" zIndex={2147483647} onClick={handleToggleChat} aria-label="Open chat" border="none" padding="0" overflow="hidden" pointerEvents="auto" data-sentry-element="Box" data-sentry-component="HubSpotChatButton" data-sentry-source-file="HubSpotChatButton.tsx">
      <Image src={ChatbotIcon} alt="Chat with us" width={CHAT_BUTTON_SIZE} height={CHAT_BUTTON_SIZE} data-sentry-element="Image" data-sentry-source-file="HubSpotChatButton.tsx" />
    </Box>;
}